import { MethodDescription } from '../method-description';

export const MinAppVersionDescription = new MethodDescription();

MinAppVersionDescription.name = 'minAppVersion';
MinAppVersionDescription.fields = [];
